import PropTypes from "prop-types"
import React from "react"

import InlineNotice from "src/components/InlineNotice"

const NOTICES = {
  processing: {
    variant: "info",
    text: "This payment is still processing. Its invoices stay in processing until it succeeds or fails.",
  },
  failed: {
    variant: "error",
    text: "This payment failed. Each invoice it covered is back to what it owed.",
  },
  refund_pending: {
    variant: "warning",
    text: "A refund is still processing. The money hasn’t gone back yet.",
  },
}

const PaymentStatusNotice = ({ status }) => {
  const notice = NOTICES[status]
  if (!notice) return null

  return (
    <div role="status">
      <InlineNotice variant={notice.variant}>{notice.text}</InlineNotice>
    </div>
  )
}

PaymentStatusNotice.propTypes = {
  status: PropTypes.string.isRequired,
}

export default PaymentStatusNotice
